import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

/** Per-type key/value project settings — mirrors stacks-agents `src/app/api/settings/`. */
@Injectable({ providedIn: 'root' })
export class SettingsApiService {
  constructor(private http: HttpClient) {}

  /** Builder JWT for the stacks-agents API. */
  private agentsAuthHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` })
  }

  getSettingsByType(projectId: string, settingsType: string): Promise<Record<string, any>> {
    return this.http
      .get<{ data?: Record<string, any> }>(`${environment.agentsUrl}v4/retrieval/settings`, {
        headers: this.agentsAuthHeaders(),
        params: { projectId, settingsType },
      })
      .pipe(
        map(body => body?.data ?? {}),
        catchError(() => of({})),
      )
      .toPromise() as Promise<Record<string, any>>
  }

  /** Upserts key/value settings rows for a settings type (e.g. "shipping", "payment"). */
  async upsertSettingsByType(projectId: string, settingsType: string, fields: Record<string, any>): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/creation/settings`, { projectId, settingsType, fields }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
  }
}